import { useLocalStorage } from "@vueuse/core";
import { ReservationsApi } from "@xs2event/js-lib/api";
import { computed } from "vue";

const toBeReleasedAllocationItems = useLocalStorage<{ allocationId: string | undefined; items: string[] }>(
  "releaseAllocationItems",
  { allocationId: undefined, items: [] }
);

export const isToBeReleasedFromAllocation = (ticketId: string) =>
  computed(() => {
    return toBeReleasedAllocationItems.value?.items?.includes(ticketId);
  });

export const markForReleaseAllocation = (allocationId: string, ticketId: string) => {
  toBeReleasedAllocationItems.value = {
    allocationId,
    items: Array.from(new Set([...(toBeReleasedAllocationItems.value?.items || []), ticketId])),
  };
};

export const unmarkForReleaseAllocation = (allocationId: string, ticketId: string) => {
  if (!toBeReleasedAllocationItems.value) {
    toBeReleasedAllocationItems.value = { allocationId, items: [] };
  }

  toBeReleasedAllocationItems.value = {
    allocationId,
    items: toBeReleasedAllocationItems.value.items?.filter((id) => id !== ticketId) || [],
  };

  console.log(toBeReleasedAllocationItems.value);
};

export const releaseMarkedAllocationItems = async () => {
  const reservationsApi = new ReservationsApi();

  const allocationId = toBeReleasedAllocationItems.value?.allocationId;
  const toBeReleasedItems = toBeReleasedAllocationItems.value?.items;

  if (!allocationId || !toBeReleasedItems?.length) return;

  const reservation = await reservationsApi.reservationGet({ reservationId: allocationId });

  await reservationsApi.reservationPut({
    reservationId: allocationId,
    reservationPut: {
      ...reservation,
      items:
        reservation.items
          ?.filter((x) => !toBeReleasedItems.includes(x.ticketId))
          .map((x) => ({ ...x, currencyCode: x.currency })) || [],
    },
  });

  toBeReleasedAllocationItems.value = { allocationId: undefined, items: [] };
};
